
import { Vue, Component } from "vue-property-decorator";
import axios from "axios";
// Components
import Snackbar from "@/components/Snackbar.vue";
// Entities
import { Warehouse } from "@/entities/index";

@Component({
  components: {
    Snackbar,
  },
})
export default class AddWarehouse extends Vue {
  addWarehouse = false;

  warehouse = {
    name: "",
    code: "",
  } as Warehouse;

  warehouses: Warehouse[] = [];

  // ========== CRUD ========== //

  createWarehouse(): void {
    axios
      .post("/api/warehouses", {
        name: this.warehouse.name,
        code: this.warehouse.code,
      })
      .then(() => {
        this.afterCreate();
      });
  }

  // ========== OTHER METHODS ========== //

  clear(): void {
    const btnClear = document.getElementById("btnClear");
    btnClear?.classList.add("clicked");
    setTimeout(() => {
      btnClear?.classList.remove("clicked");
    }, 500);

    this.warehouse.name = "";
    this.warehouse.code = "";
  }

  showSnackbar(): void {
    const snackbar = this.$refs.snackbarAddWarehouse as Snackbar;
    snackbar.show();
  }

  afterCreate(): void {
    this.clear();
    this.showSnackbar();
    this.$emit("warehouse-added", this.warehouse);
  }
}
